var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(.7071 .7071 -.7895 .7895 69.2392 -17.7043)",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0386,
    x2: 58.7966,
    y1: 68.9043,
    y2: 68.9043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5947,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7746,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2622,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#bdbdbd"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 88.8798,
    x2: 95.6655,
    xlinkHref: "#b",
    y1: 34.5181,
    y2: 41.3038
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 13.9134,
    x2: 20.7149,
    xlinkHref: "#b",
    y1: 109.4758,
    y2: 116.2774
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 68.3861,
    x2: 102.9845,
    y1: 60.1069,
    y2: 25.5085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fada80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fada80"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: -2.5097,
    x2: 21.4338,
    y1: 131.0027,
    y2: 107.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#1d2a87",
    stopOpacity: 0.814
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#243da0",
    stopOpacity: 0.5097
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#2f5cc7",
    stopOpacity: 0.127
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3367d6",
    stopOpacity: 0
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc02d"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 75.9183,
    cy: 23.0455,
    gradientTransform: "matrix(.9993 .038 -.038 .9993 .9277 -2.8392)",
    gradientUnits: "userSpaceOnUse",
    r: 14.7841,
    xlinkHref: "#g"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 99.3854,
    cy: 64.9549,
    gradientTransform: "matrix(.9392 -.3435 .3435 .9392 -17.3837 37.6633)",
    gradientUnits: "userSpaceOnUse",
    r: 11.883,
    xlinkHref: "#g"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 134.5868,
    cy: -6.3542,
    gradientTransform: "matrix(-.2474 .9423 -1.0398 -.1868 134.7166 -108.9707)",
    gradientUnits: "userSpaceOnUse",
    r: 16.4519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    stopColor: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc02d"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 92.7608,
    cy: 70.0926,
    gradientTransform: "matrix(.8599 .5105 -.306 .5153 34.4455 -13.3849)",
    gradientUnits: "userSpaceOnUse",
    r: 93.7294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffee58",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd835"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.8 123.89-6.19-6.2 91.23-91.23 6.19 6.19z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.04 28.46c-2.25-2.25-4.19-2-4.19-2l-16.12 16.12c.95-.21 2.62.6 4.11 2.08 1.48 1.48 2.29 3.15 2.08 4.11l16.12-16.12c-.01 0 .25-1.93-2-4.19z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.1 103.4c-2.25-2.25-4.19-2-4.19-2l-16.17 16.16c.95-.21 2.67.56 4.16 2.04 1.48 1.48 2.25 3.21 2.04 4.16l16.16-16.17s.25-1.94-2-4.19z",
    fill: "url(#d)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.8,
    cy: 120.7,
    fill: "#9e9e9e",
    rx: 1.94,
    ry: 4.38,
    transform: "matrix(.7071 -.7071 .7071 .7071 -83.0625 40.8672)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m95.82 26.48-67.94 67.95c-.76.76.01 2.76 1.72 4.46 1.71 1.71 3.71 2.48 4.46 1.72l67.95-67.95s.42-1.88-1.98-4.21-4.21-1.97-4.21-1.97z",
    fill: "url(#e)",
    opacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m72.59 49.71-67.94 67.95c-.76.76.01 2.76 1.72 4.46 1.71 1.71 3.71 2.48 4.46 1.72l67.96-67.94s.42-1.88-1.98-4.21c-2.41-2.32-4.22-1.98-4.22-1.98z",
    fill: "url(#f)",
    opacity: 0.22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m68.37 18.82 5.98-5.96c.33-.33.9-.06.85.41l-.77 6.99c-.03.27.16.52.44.55l8.56 1.02c.5.06.61.74.14.95l-8.92 3.99c-.13.06-.23.18-.27.32l-2.58 8.85c-.12.43-.7.49-.91.1l-3.99-7.25c-.09-.17-.28-.27-.48-.26l-7.66.62c-.47.04-.72-.53-.39-.85l5.08-4.95c.15-.14.19-.37.11-.56l-2.69-6.15c-.18-.42.25-.85.67-.65l6.29 2.94c.17.08.39.04.54-.11z",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m90.09 63.26 4.74 2.19c.12.06.26.04.36-.04l4.75-3.59c.25-.19.59.01.57.31l-.45 5.9c-.01.13.05.26.17.33l4.53 2.8c.27.17.2.59-.12.65l-5.68 1.17c-.14.03-.25.13-.28.27l-1.21 5.35c-.07.32-.5.38-.66.09l-2.52-4.61c-.06-.12-.19-.19-.32-.19l-5.96.19c-.31.01-.48-.35-.29-.59l3.84-4.59c.09-.1.11-.24.06-.37l-2.02-4.82c-.11-.29.2-.59.49-.45z",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m109.65 11.65 8.43-3.74c.42-.19.79.23.57.63l-4.17 7.68c-.1.18-.08.4.05.54l9.03 8.76c.27.28.04.78-.37.8l-11.08-1.95c-.17.01-.33.11-.42.27l-5.83 10.67c-.22.39-.78.35-.87-.06l-1.14-10.39c-.04-.18-.2-.31-.39-.33l-9.15-1.49c-.39-.03-.54-.5-.24-.79l7.65-5.88c.11-.11.17-.26.15-.41l-1.37-11.58c-.04-.44.51-.73.82-.43l7.82 7.62c.13.12.33.15.51.08z",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m96.29 26.87c-3.74.96-7.53 1.79-11.4 2.11-3.87.35-7.8.07-11.62-.62-3.82-.71-7.57-1.6-11.35-2.3s-7.58-1.26-11.4-1.7c-1.91-.22-3.83-.38-5.74-.57-1.87-.18-3.72-.13-5.48.28-1.73.44-3.34 1.27-4.38 2.63-1.05 1.34-1.55 3.08-1.55 4.87-.02 3.61 1.43 7.21 3.27 10.46 1.85 3.27 4.28 6.24 6.71 9.21 4.84 5.96 10.07 11.63 15.26 17.34 2.6 2.86 5.2 5.71 7.76 8.61 2.58 2.88 5.07 5.85 7.45 8.91 2.39 3.05 4.66 6.24 6.51 9.7.46.84.97 1.77 1.12 2.89.05.57-.01 1.2-.33 1.76s-.85.91-1.36 1.14c-1.05.42-2.09.45-3.09.4-1-.06-1.98-.22-2.94-.44-3.82-.93-7.39-2.52-10.83-4.31-1.72-.9-3.4-1.86-5.05-2.87-1.64-1.02-3.25-2.1-4.83-3.2 3.28 2.04 6.64 3.94 10.11 5.59 3.47 1.64 7.08 3.07 10.79 3.82.93.17 1.86.31 2.78.34s1.85-.05 2.59-.37c.36-.17.66-.39.81-.69.15-.29.19-.66.15-1.05-.12-.8-.55-1.6-1.04-2.43-1.87-3.3-4.16-6.38-6.6-9.34-9.76-11.84-20.88-22.6-30.8-34.54-2.43-3.01-4.89-6.07-6.82-9.54-1.9-3.44-3.47-7.26-3.42-11.43.02-2.06.62-4.23 1.98-5.93 1.35-1.73 3.37-2.73 5.36-3.21 2.01-.44 4.07-.49 6.04-.26 1.92.24 3.85.44 5.77.71 3.84.54 7.66 1.2 11.45 1.99 3.79.8 7.54 1.76 11.29 2.57 3.74.82 7.56 1.25 11.4 1.05 3.83-.18 7.64-.83 11.43-1.58z",
    fill: "#fdd835"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m67.78 35.64c-11.25 2.62-24.16-5-36.08-3.66-4.55.6-6.42 6.04-2.05 14.66 8.58 14.77 21.1 23.49 25.72 28.9-6.21-3.48-18.97-12.65-27.84-21.28-13.35-12.8-10.88-28.8 1.5-28.75 4.15-.4 12.18 1.6 15.54 2.83 3.31 1.33 14.58 6.24 23.21 7.3z",
    fill: "url(#k)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.18c4ab9af6c6ffff66bf84d914f0008d.svg";
export { ForwardRef as ReactComponent };